import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, requireApproved = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#4A5D4E]" data-testid="auth-loading">
        Chargement...
      </div>
    );
  }
  if (!user) {
    const target = adminOnly ? "/admin-finefood-login" : "/login";
    return <Navigate to={target} state={{ from: location.pathname }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (requireApproved && user.role !== "admin" && user.status !== "approved") {
    return <Navigate to="/pending" replace />;
  }
  return children;
}
